import { ErrorMessage, Field, FieldArray, Form, Formik } from "formik";
import { arrowLeft, briefcase, downloadIcon, setting } from "../../constant/icons";
import { Button, Card, Col, Dropdown, DropdownToggle, FormGroup, Label, Nav, NavItem, NavLink, TabContent, TabPane, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { plus } from "../../constant/icons";
import PageLayout from "../layout/page";
import { useEffect, useState } from "react";
import { ContactPerson } from "./contactPerson";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { getDate } from "../../helper/utility";
import { get, post } from "../../helper/api";
import { useApp } from "../../components/app";
import { companyValidationSchema } from "./validationSchema";
import { message } from "../../components/toast";
import reactSelect from "react-select";
import { useLoaderHelper } from "../../helper/loaderHelper";
import { FileUpload } from "../job/type";
import { BrowserFile } from "../job/addUpdate/wizardBox/steps/browserFile";
import { SubscriptionView } from "./subscription";

const AddUpdateCompany = (props: any) => {
  const loader = useLoaderHelper()
  const app = useApp();
  const [fileUpload, setFileUpload] = useState<FileUpload[]>([]);
  const [refresh, setRefresh] = useState<boolean>(false);
  const { api, value, closeAddUpdate } = props;
  const [payrollBusinesses, setPayrollBusinesses] = useState<any[]>([]);
  const [formValues, setFormValues] = useState(value)
  const [payrollEnabled, setPayrollEnabled] = useState<boolean>(value?.company_settings?.payrollEnabled ?? false);
  const [payrollModalOpen, setPayrollModalOpen] = useState(false);
  const [payrollApiKey, setPayrollApiKey] = useState<string>("");
  const togglePayrollModal = () => setPayrollModalOpen(!payrollModalOpen);
  const [subscriptionModalOpen, setSubscriptionModalOpen] = useState(false);
  const attemptConnectTenant = (companyId: any) => {
    get("/connectTenant", { companyId }, loader)
      .then((response) => {
        if (response?.status && response?.data.length > 0) {
          window.location.href = response?.data[0];
        } else if (!response?.status && app.currentApp?.appCode === "xero") {
          setSubscriptionModalOpen(true);
        }
      })
      .catch(() => { });
  };
  const fetchPayrollBusinesses = async (apiKey: string) => {
    if (!apiKey) {
      message("error", "Payroll API Key is required");
      return;
    }
    try {
      const res = await get(
        "/qbo/allBusiness",
        { apiKey },
        loader
      );
      if (res?.status) {
        setPayrollBusinesses(res.data || []);
        setPayrollModalOpen(true);
      }
    } catch (err) {
      message("error", "Invalid Payroll API Key");
    }
  };
  const toggleTab = (tab: string) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
    }
  };
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const toggle = () => setDropdownOpen((prevState: any) => !prevState);
  const [appName, setAppName] = useState("App")
  useEffect(() => {
    if (app.currentApp?.appCode) {

      if (app.currentApp?.appCode == "xero") {
        setAppName("XERO")
      }
      else if (app.currentApp?.appCode == "QBO") {
        setAppName("QuickBooks")
      }
      else if (app.currentApp?.appCode == "zoho") {
        setAppName("ZOHO")
      }
      else if (app.currentApp?.appCode == "odoo") {
        setAppName("ODOO")
      }
    }
    else {
      setAppName("App")
    }

  }, [app.currentApp?.appCode])
  /* ================= Payroll Business List ================= */
  // useEffect(() => {
  //   if (app.currentApp?.appCode !== "QBO" || payrollEnabled !== true) {
  //     return;
  //   }
  //   get("/qbo/allBusiness", {}, loader)
  //     .then((res) => {
  //       if (res?.status) {
  //         setPayrollBusinesses(res.data || []);
  //       }
  //     })
  //     .catch((err) => {
  //       console.error("Failed to fetch payroll businesses", err);
  //     });
  // }, [
  //   app.currentApp?.appCode,
  //   payrollEnabled
  // ]);

  const toggleTab2 = (tab: string) => {
    if (activesettingTab !== tab) {
      setActivesettingTab(tab);
    }
  };
  const [activeTab, setActiveTab] = useState("tab1");
  const [activesettingTab, setActivesettingTab] = useState("settingtab1");

  const handleSubmit = async (values: any, actions: any, formValues: any, fileUpload: FileUpload[], api: any, loader: any, closeAddUpdate: any) => {
    const formData = new FormData();

    try {
      let result;
      if (!values?.id && !values?.company_settings?.payrollEnabled) {
        delete values.company_settings.payrollBusinessId;
        delete values.company_settings.payrollBusinessKey;
        delete values.company_settings.payrollBusinessName;
        delete values.company_settings.payrollBusiness;
      }

      // REMOVE orderId if appCode is NOT xero
      if (app.currentApp?.appCode !== "xero") {
        delete values.company_settings?.orderId;
      }
      if (values.company_settings.excelMapping && !(values.company_settings.fileNames && Object.keys(values.company_settings.fileNames).length > 0) && fileUpload.length == 0) {
        message("error", "Excel File Required While you Enabled Excel Mappping Toggle");
      } else {

        // Append files (if any)
        if (fileUpload.length) {
          fileUpload.forEach((file: FileUpload) => {
            if (file.file) {
              formData.append("files", file.file);
            }
          });
        }
        if (!values.company_settings.excelMapping && Object.keys(values.company_settings?.fileNames ?? {}).length) {
          delete values.company_settings?.fileNames
        }
        // Append payload as JSON string
        formData.append("payload", JSON.stringify(values));

        if (values?.id > 0) {
          result = await api.updateValue(formData, loader, {
            headers: { "Content-Type": "multipart/form-data" },
          });
        } else {
          result = await api.create(formData, {
            headers: { "Content-Type": "multipart/form-data" },
          });
        }
        /* } else {
          if (values?.id > 0) {
            result = await api.updateValue(values, loader);
          } else {
            result = await api.create(values);
          }
        } */

      }

      if (result?.status) {
        closeAddUpdate();
      }
    } catch (error) {
      console.error(error);
    }
  }
  return (
    <PageLayout
      title={
        <>
          <Button
            color="link"
            className="btn-back"
            onClick={() => props.closeAddUpdate()}
          >
            {arrowLeft.icon}
          </Button>
          {value?.id ? "Edit" : "Add"} Company
        </>
      }
      View={
        <div className="company_form">
          <Nav tabs>
            <NavItem>
              <NavLink
                className={activeTab === "tab1" ? "active" : ""}
                onClick={() => toggleTab("tab1")}
              >
                {briefcase.icon}Details
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                className={activeTab === "tab2" ? "active" : ""}
                onClick={() => toggleTab("tab2")}
              >
                {setting.icon}Setting
              </NavLink>
            </NavItem>
          </Nav>
          <Formik
            initialValues={{
              ...formValues,
              company_settings: {
                payrollEnabled: formValues?.company_settings?.payrollEnabled ?? false,
                payrollBusinessId: formValues?.company_settings?.payrollBusinessId ?? "",
                payrollBusinessKey: formValues?.company_settings?.payrollBusinessKey ?? "",
                payrollBusinessName: formValues?.company_settings?.payrollBusinessName ?? "",
                date: formValues?.company_settings?.date ?? null,
                dateFormat: formValues?.company_settings?.dateFormat ?? "dd/MM/yyyy",
                orderId: formValues?.orderId ?? "",
                tally_migration: formValues?.company_settings?.tally_migration ?? false,
                tally_migration_start_date: formValues?.company_settings?.tally_migration_start_date ?? null,
                tally_migration_end_date: formValues?.company_settings?.tally_migration_end_date ?? null,
                tally_company_name: formValues?.company_settings?.tally_company_name ?? "",
                tally_serial_no: formValues?.company_settings?.tally_serial_no ?? "",
                ...formValues?.company_settings,
              }
            }}
            validationSchema={companyValidationSchema(app?.currentApp?.appCode)}
            onSubmit={(values, actions) =>
              handleSubmit(values, actions, formValues, fileUpload, api, loader, closeAddUpdate)
            }
          >
            {(formProps) => (
              <Form className="mx-0">
                <TabContent activeTab={activeTab}>
                  <TabPane tabId="tab1">
                    <div className="form-row">
                      <FormGroup className="col-3 form-floating mb-0">
                        <Field
                          className="form-control"
                          name="name"
                          placeholder="Conversation Name"
                        />
                        <ErrorMessage
                          name="name"
                          component="div"
                          className="text-danger"
                        />
                        <Label>Company name <span style={{ color: 'red' }}>*</span></Label>
                      </FormGroup>
                      <FormGroup className="col-3 form-floating mb-0">
                        <Field
                          className="form-control"
                          type="email"
                          name="email"
                          placeholder="Email"
                        />
                        <ErrorMessage
                          name="email"
                          component="div"
                          className="text-danger"
                        />
                        <Label>Email <span style={{ color: 'red' }}>*</span></Label>
                      </FormGroup>
                      <FormGroup className="col-3 form-floating sticky_label mb-0">
                        <Field
                          name="company_settings.dateFormat"
                          component={reactSelect}
                          className="column_field_select"
                          menuPortalTarget={document.body}
                          menuPlacement="auto"
                          menuPosition={'fixed'}

                          onChange={(newValue: any) => {
                            formProps.setFieldValue("company_settings.dateFormat", newValue.value);
                          }}
                          value={{
                            value: formProps.values?.company_settings?.dateFormat || "dd/MM/yyyy",
                            label: formProps.values?.company_settings?.dateFormat || "dd/MM/yyyy"
                          }}
                          options={[{
                            value: "dd/MM/yyyy",
                            label: "DD/MM/YYYY"
                          }, {
                            value: "MM/dd/yyyy",
                            label: "MM/DD/YYYY"
                          }]}
                          placeholder={<div>Select column field</div>}
                        />
                        <ErrorMessage
                          name="company_settings.dateFormat"
                          component="div"
                          className="text-danger"
                        />
                        <Label>Preferred Date Format</Label>
                      </FormGroup>
                      <FormGroup className="col-3 form-floating sticky_label mb-0">
                        <Field
                          component={DatePicker}
                          placeholderText={formProps.values?.company_settings?.dateFormat || "dd/MM/yyyy"}
                          dateFormat={formProps.values?.company_settings?.dateFormat || "dd/MM/yyyy"}
                          className="form-control"
                          name="company_settings.date"
                          selected={getDate(formProps.values?.company_settings?.date)}
                          onChange={(date: any, _: any) => {
                            console.log("demoDate", formProps.values?.company_settings?.dateFormat)
                            formProps.setFieldValue("company_settings.date", date);
                          }}
                        />
                        <ErrorMessage
                          name="company_settings.date"
                          component="div"
                          className="text-danger"
                        />
                        <Label>conversion Start date <span style={{ color: 'red' }}>*</span></Label>
                      </FormGroup>
                      {app.currentApp?.appCode === "xero" && (
                        <FormGroup className="col-3 form-floating mb-0">
                          <Field
                            className="form-control"
                            name="company_settings.orderId"
                            placeholder="Order number"
                          />
                          <ErrorMessage
                            name="company_settings.orderId"
                            component="div"
                            className="text-danger"
                          />
                          <Label>
                            Order number <span style={{ color: "red" }}>*</span>
                          </Label>
                        </FormGroup>
                      )}
                      {/* QBO – Payroll */}
                      {app.currentApp?.appCode === "QBO" && (
                        <>
                          <FormGroup className="col-3 mb-3">
                            <Label className="d-block mb-1">Payroll</Label>

                            <Field name="company_settings.payrollEnabled">
                              {({ field }: any) => (
                                <div className="form-check form-switch payroll-switch ms-2">
                                  <input
                                    type="checkbox"
                                    className="form-check-input m-0"
                                    checked={field.value === true}
                                    onChange={(e) => {
                                      const enabled = e.target.checked;
                                      formProps.setFieldValue("company_settings.payrollEnabled", enabled);
                                      setPayrollEnabled(enabled);
                                      if (!e.target.checked) {
                                        formProps.setFieldValue(
                                          "company_settings.payrollBusinessId",
                                          ""
                                        );
                                      }
                                    }}
                                  />
                                </div>
                              )}
                            </Field>
                          </FormGroup>
                          {formProps.values.company_settings.payrollEnabled === true && (
                            (() => {
                              const businessOptions = payrollBusinesses.map((b: any) => ({
                                label: b.name || b.legalName || `Business #${b.id}`,
                                value: b.id
                              }));

                              return (
                                // <FormGroup className="col-3 form-floating sticky_label mb-0">
                                //   <Field
                                //     name="company_settings.payrollBusinessId"
                                //     component={reactSelect}
                                //     className="column_field_select"
                                //     menuPortalTarget={document.body}
                                //     menuPlacement="auto"
                                //     menuPosition="fixed"
                                //     options={businessOptions}
                                //     placeholder="Select Business"
                                //     onChange={(option: any) => {
                                //       formProps.setFieldValue(
                                //         "company_settings.payrollBusinessId",
                                //         option?.value
                                //       );
                                //       const selectedBusiness = payrollBusinesses.find(
                                //         (b: any) => b.id === option?.value
                                //       );

                                //       if (selectedBusiness) {
                                //         formProps.setFieldValue(
                                //           "company_settings.payrollBusiness",
                                //           {
                                //             id: selectedBusiness.id,
                                //             name: selectedBusiness.name,
                                //             contactEmailAddress: selectedBusiness.contactEmailAddress
                                //           }
                                //         );
                                //       }
                                //     }}
                                //     value={
                                //       businessOptions.find(
                                //         (opt: any) =>
                                //           opt.value ===
                                //           formProps.values.company_settings.payrollBusinessId
                                //       ) || null
                                //     }
                                //   />
                                //   <ErrorMessage
                                //     name="company_settings.payrollBusinessId"
                                //     component="div"
                                //     className="text-danger"
                                //   />
                                //   {/* <Label>Business ID</Label> */}
                                //   <Label>Payroll Business</Label>
                                // </FormGroup>
                                <FormGroup className="col-3 form-floating mb-0 position-relative">
                                  <Field name="company_settings.payrollBusinessKey">
                                    {({ field }: any) => (
                                      <>
                                        <input
                                          {...field}
                                          type="text"
                                          className="form-control pe-5"
                                          placeholder="Enter Payroll API Key"
                                          onChange={(e) => {
                                            field.onChange(e);
                                            setPayrollApiKey(e.target.value);
                                          }}
                                        />
                                        <span
                                          className="position-absolute top-50 end-0 translate-middle-y me-3"
                                          style={{ cursor: "pointer" }}
                                          onClick={() => {
                                            // fetchPayrollBusinesses(payrollApiKey);
                                            fetchPayrollBusinesses(
                                              formProps.values?.company_settings?.payrollBusinessKey
                                            );
                                          }}
                                        >
                                          🔍
                                        </span>
                                      </>
                                    )}
                                  </Field>
                                  <Label>Payroll API Key</Label>
                                </FormGroup>
                              );
                            })()
                          )}
                        </>
                      )}
                      {/* ===== Payroll Business Status (QBO only) ===== */}
                      <div className="col-12 mb-2">
                        {app.currentApp?.appCode === "QBO" &&
                          formProps.values?.company_settings?.payrollEnabled && (
                            <Button
                              color="primary"
                              type="button"
                              disabled={
                                !formProps.values?.company_settings?.payrollBusinessId
                              }
                              onClick={() => {
                                if (!formProps.values?.company_settings?.payrollBusinessId) {
                                  message("warning", "Please select Payroll Business");
                                }
                              }}
                            >
                              {formProps.values?.company_settings?.payrollBusinessId
                                ? `Linked to Payroll Business ${formProps.values?.company_settings?.payrollBusinessName}`
                                : "Select Payroll Business"}
                            </Button>
                          )}
                      </div>
                      {app.currentApp?.appCode == "zoho" && <>
                        <FormGroup className="col-12 mb-2 form-floating sticky_label ">
                          <Field
                            name="company_settings.region"
                            component={reactSelect}
                            className="column_field_select"
                            menuPortalTarget={document.body}
                            menuPlacement="auto"
                            menuPosition={'fixed'}
                            onChange={(newValue: any) => {
                              formProps.setFieldValue("company_settings.region", newValue.value);
                            }}
                            value={{
                              value: formProps.values?.company_settings?.region || "IN",
                              label: formProps.values?.company_settings?.region || "India (zoho.in)"
                            }}
                            options={[
                              {
                                value: "IN",
                                label: "India (zoho.in)"
                              },
                              {
                                value: "AE",
                                label: "United Arab Emirates (zoho.ae)"
                              },
                              {
                                value: "US",
                                label: "US (zoho.com)"
                              },
                              {
                                value: "EU",
                                label: "Europe (zoho.eu)"
                              },
                              {
                                value: "CA",
                                label: "Canada (zohocloud.ca)"
                              },
                              {
                                value: "AU",
                                label: "Australia (zoho.com.au)"
                              },
                              {
                                value: "UK",
                                label: "UK (zoho.uk)"
                              },
                              {
                                value: "JP",
                                label: "Japanese (zoho.jp)"
                              },
                              {
                                value: "SA",
                                label: "Saudi Arabian (zoho.sa)"
                              },
                              {
                                value: "AE",
                                label: "United Arab Emirates (zoho.ae)"
                              }
                            ]}
                            placeholder={<div>Select Region</div>}
                          />
                          <ErrorMessage
                            name="company_settings.region"
                            component="div"
                            className="text-danger"
                          />
                          <Label>Select Region <span style={{ color: 'red' }}>*</span></Label>
                          {/*   <Input
                            type="select"
                            id="zohoRegion"
                            name="zohoRegion"
                            value={zohoRegion}
                            required
                            onChange={(e) => setZohoRegion(e.target.value)}
                          >
                            <option value="">Select Region</option>
                            <option value="IN">India (zoho.in)</option>
                            <option value="US">US (zoho.com)</option>
                            <option value="EU">Europe (zoho.eu)</option>
                            <option value="CA">Canada (zoho.ca)</option>
                            <option value="AU">Australia (zoho.com.au)</option>
                            <option value="UK">UK (zoho.uk)</option>
                          </Input> */}
                        </FormGroup>
                        <FormGroup className="col-12 mb-3">
                          <div className="d-flex  align-items-center">
                            <div className="d-flex justify-content-between align-items-center">
                              <Label for="excelMapping" className="mb-0">
                                Excel Mapping
                              </Label>
                            </div>
                            <Field name="company_settings.excelMapping">
                              {({ field }: any) => (
                                <div className="form-check form-switch mx-5 position-relative">
                                  <input
                                    {...field}
                                    id="excelMapping"
                                    type="checkbox"
                                    className="form-check-input"
                                    checked={field.value || false}
                                  />
                                </div>
                              )}
                            </Field>

                            {/* File name preview with remove option */}
                            {formProps.values?.company_settings?.excelMapping &&
                              formProps.values?.company_settings?.fileNames?.originalFilename && (
                                <div className="d-flex align-items-center gap-2 ms-3">
                                  <span style={{ fontSize: "18px" }}>📄</span>
                                  <span>{formProps.values?.company_settings?.fileNames?.originalFilename}</span>
                                </div>
                              )}
                          </div>
                          <Field name="company_settings.excelMapping">
                            {({ field }: any) =>
                              field.value ? (
                                <div className="mt-3">
                                  <BrowserFile
                                    fileUpload={fileUpload}
                                    onFileUpdate={setFileUpload}
                                    onFileUpdateRefresh={setRefresh}
                                  />
                                </div>
                              ) : null
                            }
                          </Field>
                        </FormGroup>
                      </>}
                      <FormGroup className="col-12 form-floating mb-0">
                        <Field
                          className="form-control"
                          component="textarea"
                          rows="4"
                          name="remark"
                          placeholder="Remark"
                        />
                        <ErrorMessage
                          name="remark"
                          component="div"
                          className="text-danger"
                        />
                        <Label>Remark</Label>
                      </FormGroup>
                      {app.currentApp?.appCode == "rdo" && <>
                        <p>Your connection ID is: <strong>${btoa(formProps.values?.tenant?.[0]?.id)}</strong></p>
                      </>}
                      {app.currentApp?.appCode == "odoo" && <>
                        <FormGroup className="col-3 form-floating sticky_label mb-0">
                          <Field
                            name="company_settings.version"
                            component={reactSelect}
                            className="column_field_select"
                            menuPortalTarget={document.body}
                            menuPlacement="auto"
                            menuPosition={'fixed'}

                            onChange={(newValue: any) => {
                              formProps.setFieldValue("company_settings.version", newValue.value);
                            }}
                            value={{
                              value: formProps.values?.company_settings?.version || 18,
                              label: formProps.values?.company_settings?.version || "18"
                            }}
                            options={(Array.isArray(app.currentApp.details) ? app.currentApp.details?.map((ver: any) => ({
                              label: ver.name,
                              value: ver.value
                            })) : [])}
                            placeholder={<div>Select column field</div>}
                          />
                          <ErrorMessage
                            name="company_settings.version"
                            component="div"
                            className="text-danger"
                          />
                          <Label>Odoo Database Version <span style={{ color: 'red' }}>*</span></Label>
                        </FormGroup>
                        <FormGroup className="col-3 form-floating mb-0">
                          <Field
                            className="form-control"
                            name="company_settings.Odoo_hostingUrl"
                            placeholder="Conversation Name"
                          />
                          <ErrorMessage
                            name="company_settings.Odoo_hostingUrl"
                            component="div"
                            className="text-danger"
                          />
                          <Label>Odoo Hosting URL <span style={{ color: 'red' }}>*</span></Label>
                        </FormGroup>
                        <FormGroup className="col-3 form-floating mb-0">
                          <Field
                            className="form-control"
                            name="company_settings.Odoo_UserName"
                            placeholder="Conversation Name"
                          />
                          <ErrorMessage
                            name="company_settings.Odoo_UserName"
                            component="div"
                            className="text-danger"
                          />
                          <Label>Odoo UserName <span style={{ color: 'red' }}>*</span></Label>
                        </FormGroup>
                        <FormGroup className="col-3 form-floating mb-0">
                          <Field
                            className="form-control"
                            name="company_settings.Odoo_Password"
                            placeholder="Odoo API Key"
                          />
                          <ErrorMessage
                            name="company_settings.Odoo_Password"
                            component="div"
                            className="text-danger"
                          />
                          <Label>Odoo API Key <span style={{ color: 'red' }}>*</span></Label>
                        </FormGroup>
                        <FormGroup className="col-3 form-floating mb-0">
                          <Field
                            className="form-control"
                            name="company_settings.Odoo_DataBaseName"
                            placeholder="Conversation Name"
                          />
                          <ErrorMessage
                            name="company_settings.Odoo_DataBaseName"
                            component="div"
                            className="text-danger"
                          />
                          <Label>Odoo DataBaseName <span style={{ color: 'red' }}>*</span></Label>
                        </FormGroup>

                      </>}
                      {app.currentApp?.appCode && ["odoo", "zoho"].includes(app.currentApp?.appCode) && <>
                        <FormGroup className="col-12 mb-3">
                          <div className="d-flex  align-items-center">
                            <div className="d-flex justify-content-between align-items-center">
                              <Label for="excelMapping" className="mb-0">
                                Tally Migration
                              </Label>
                            </div>
                            <Field name="company_settings.tally_migration">
                              {({ field }: any) => (
                                <div className="form-check form-switch mx-5 position-relative">
                                  <input
                                    {...field}
                                    id="tally_migration"
                                    type="checkbox"
                                    className="form-check-input"
                                    checked={field.value || false}
                                  />
                                </div>
                              )}
                            </Field>
                          </div>
                        </FormGroup>
                        {formProps.values?.company_settings?.tally_migration && <>
                        <FormGroup className="col-3 form-floating sticky_label mb-0">
                          <Field
                            component={DatePicker}
                            placeholderText={formProps.values?.company_settings?.dateFormat || "dd/MM/yyyy"}
                            dateFormat={formProps.values?.company_settings?.dateFormat || "dd/MM/yyyy"}
                            className="form-control"
                            name="company_settings.tally_migration_start_date"
                            selected={getDate(formProps.values?.company_settings?.tally_migration_start_date)}
                            onChange={(date: any, _: any) => {
                              formProps.setFieldValue("company_settings.tally_migration_start_date", date);
                            }}
                          />
                          <ErrorMessage
                            name="company_settings.tally_migration_start_date"
                            component="div"
                            className="text-danger"
                          />
                          <Label>Tally Migration Period Start date <span style={{ color: 'red' }}>*</span></Label>
                        </FormGroup>
                        <FormGroup className="col-3 form-floating sticky_label mb-0">
                          <Field
                            component={DatePicker}
                            placeholderText={formProps.values?.company_settings?.dateFormat || "dd/MM/yyyy"}
                            dateFormat={formProps.values?.company_settings?.dateFormat || "dd/MM/yyyy"}
                            className="form-control"
                            name="company_settings.tally_migration_end_date"
                            selected={getDate(formProps.values?.company_settings?.tally_migration_end_date)}
                            onChange={(date: any, _: any) => {
                              formProps.setFieldValue("company_settings.tally_migration_end_date", date);
                            }}
                          />
                          <ErrorMessage
                            name="company_settings.tally_migration_end_date"
                            component="div"
                            className="text-danger"
                          />
                          <Label>Tally Migration Period End date <span style={{ color: 'red' }}>*</span></Label>
                        </FormGroup>
                        <FormGroup className="col-3 form-floating mb-0">
                          <Field
                            className="form-control"
                            name="company_settings.tally_company_name"
                            placeholder="Company Name in Tally"
                          />
                          <ErrorMessage
                            name="company_settings.tally_company_name"
                            component="div"
                            className="text-danger"
                          />
                          <Label>Company Name in Tally <span style={{ color: 'red' }}>*</span></Label>
                        </FormGroup>
                        <FormGroup className="col-3 form-floating mb-0">
                          <Field
                            className="form-control"
                            name="company_settings.tally_serial_no"
                            placeholder="Tally Serial No"
                          />
                          <ErrorMessage
                            name="company_settings.tally_serial_no"
                            component="div"
                            className="text-danger"
                          />
                          <Label>Tally serial no <span style={{ color: 'red' }}>*</span></Label>
                        </FormGroup>

                        <FormGroup className="col-3 form-floating mb-0 d-flex gap-2 align-items-start">
                          <Dropdown isOpen={dropdownOpen} toggle={toggle}>
                            <DropdownToggle color='secondary'>
                              <span>
                                {downloadIcon.icon}
                              </span>
                              {app.currentApp?.templateUrl && <a className="m-0" href={"https://gitrepo.hcshub.com/Satish/TALLY-TDL/archive/main.zip"} target="_blank" style={{ color: 'white' }}>Download TDL</a>}
                            </DropdownToggle>
                          </Dropdown>
                          {/* <div style={!formProps.values?.company_settings?.tally_company_name ? { display: 'inline-block', cursor: 'not-allowed' } : {}}>
                            <Button
                              disabled={!formProps.values?.company_settings?.tally_company_name}
                              color="secondary"
                              size="md"
                              onClick={async () => {
                                const response = await post("/exportTallyTrialBalances", { tallyCompanyName: formProps.values?.company_settings?.tally_company_name, companyName: formProps.values?.name }, true);
                                if (response.status === 200 && response?.data?.status === undefined) {
                                  const blob = new Blob([response.data], { type: "application/zip" });
                                  const link = document.createElement("a");
                                  link.href = window.URL.createObjectURL(blob);
                                  link.download = `TrialBalance_${Date.now()}.zip`;
                                  document.body.appendChild(link);
                                  link.click();
                                  document.body.removeChild(link);
                                } else {
                                  message("error", response?.statusText ?? "Something went wrong");
                                }
                              }}
                            >
                              File Download
                            </Button>
                          </div> */}
                          <div style={!formProps.values?.company_settings?.tally_company_name ? { display: 'inline-block', cursor: 'not-allowed' } : {}}>
                            <Button
                              style={{ height: '40px' }}
                              disabled={!formProps.values?.company_settings?.tally_company_name}
                              color="secondary"
                              size="md"
                              onClick={async () => {
                                const response = await post("/comparativepdf", { tallyCompanyName: formProps.values?.company_settings?.tally_company_name, companyName: formProps.values?.name }, true, loader);
                                if (response.status === 200 && response?.data?.status === undefined) {
                                  const blob = new Blob([response.data], { type: "application/zip" });
                                  const link = document.createElement("a");
                                  link.href = window.URL.createObjectURL(blob);
                                  link.download = `TrialBalanceAndComparativeARAP_${Date.now()}.zip`;
                                  document.body.appendChild(link);
                                  link.click();
                                  document.body.removeChild(link);
                                } else {
                                  message("error", response?.statusText ?? "Something went wrong");
                                }
                              }}
                            >
                              <span>
                                {downloadIcon.icon}
                              </span>
                              Comparative Pdf Download
                            </Button>
                          </div>
                        </FormGroup>
                        </>}

                      </>
                      }

                      <Col lg="12">
                        <FieldArray name="contact_person">
                          {(actions: any) => (
                            <Card className="contact_person">
                              <div className="d-flex justify-content-between align-items-center px-3 py-2">
                                <h6>Contact person details</h6>
                                <Button
                                  color="secondary"
                                  size="sm"
                                  onClick={() => {
                                    if (!formProps.errors.contact_person) {
                                      actions.insert(
                                        formProps.values.contact_person.length,
                                        ""
                                      );
                                    }
                                    else {
                                      message("warning", "Please, kindly complete the contact person information first.")
                                    }
                                  }}
                                >
                                  {plus.icon} Add person
                                </Button>
                              </div>

                              {formProps.values.contact_person.map(
                                (contactPerson: any, index: number) => {
                                  return (
                                    <ContactPerson
                                      key={`cps${index}`}
                                      formProps={formProps}
                                      id={index}
                                      contactPerson={contactPerson}
                                      actions={actions}
                                    />
                                  );
                                }
                              )}
                            </Card>
                          )}
                        </FieldArray>
                      </Col>
                    </div>
                  </TabPane>
                  <TabPane tabId="tab2">
                    <div className="company_setting">
                      <Nav tabs>
                        <NavItem>
                          <NavLink
                            className={
                              activesettingTab === "settingtab1" ? "active" : ""
                            }
                            onClick={() => toggleTab2("settingtab1")}
                          >
                            General
                          </NavLink>
                        </NavItem>
                        <NavItem>
                          <NavLink
                            className={
                              activesettingTab === "settingtab2" ? "active" : ""
                            }
                            onClick={() => toggleTab2("settingtab2")}
                          >
                            Transactions
                          </NavLink>
                        </NavItem>
                      </Nav>
                      <TabContent activesettingTab={activesettingTab}>
                        <TabPane tabId="settingtab1">
                          <h4>Tab 1 Content</h4>
                          {/* Add your content for Tab 1 here */}
                        </TabPane>
                        <TabPane tabId="settingtab2">
                          <h4>Tab 2 Content</h4>
                          {/* Add your content for Tab 2 here */}
                        </TabPane>
                        {/* Add more TabPanes for additional tabs */}
                      </TabContent>
                    </div>
                  </TabPane>
                  <Col
                    lg="12"
                    className="d-flex justify-content-between align-items-center mt-3"
                  >
                    {formProps.values?.id && (
                      <Button
                        disabled={
                          formProps.values?.tenant &&
                          formProps.values?.tenant?.[0]?.id > 0
                        }
                        color="primary"
                        type="button"
                        onClick={() => {
                          if (formProps.values?.tenant) {
                            attemptConnectTenant(formProps.values?.id);
                          }
                        }}
                      >
                        {formProps.values?.tenant &&
                          formProps.values?.tenant?.[0]?.id > 0
                          ? `Linked to the ${appName} ${formProps.values?.tenant?.[0].tenantName}`
                          : `Connect to ${appName} Tenant`}
                      </Button>
                    )}

                    <Button color="primary" type="submit">
                      {formProps.values?.id > 0 ? "Update" : "Save"}
                    </Button>
                  </Col>
                </TabContent>
                {/* ✅ ADD MODAL HERE (BOTTOM OF FORM) */}
                {/* <Modal
                  isOpen={payrollModalOpen}
                  toggle={togglePayrollModal}
                  size="xl"
                  centered
                > */}
                <Modal
                  isOpen={payrollModalOpen}
                  toggle={togglePayrollModal}
                  size="xl"
                  centered
                  scrollable
                  dialogClassName="modal-dialog-centered modal-dialog-scrollable modal-xl"
                  contentClassName="h-50"
                >

                  <ModalHeader toggle={togglePayrollModal}>
                    Select Payroll Business
                  </ModalHeader>

                  <ModalBody>
                    <Field
                      name="company_settings.payrollBusinessId"
                      component={reactSelect}
                      className="column_field_select"
                      menuPortalTarget={document.body}
                      menuPlacement="auto"
                      menuPosition="fixed"
                      styles={{
                        menuPortal: (base: any) => ({
                          ...base,
                          zIndex: 9999,
                        }),
                      }}
                      placeholder="Select Payroll Business"
                      options={payrollBusinesses.map((b: any) => ({
                        label: b.name || b.legalName,
                        value: b.id,
                        raw: b,
                      }))}
                      value={
                        payrollBusinesses
                          .map((b: any) => ({
                            label: b.name || b.legalName,
                            value: b.id,
                            raw: b,
                          }))
                          .find(
                            (opt: any) =>
                              opt.value ===
                              formProps.values?.company_settings?.payrollBusinessId
                          ) || null
                      }
                      onChange={(option: any) => {
                        const b = option.raw;
                        formProps.setFieldValue(
                          "company_settings.payrollBusinessId",
                          b.id
                        );
                        formProps.setFieldValue(
                          "company_settings.payrollBusinessName",
                          b.name || b.legalName
                        );
                        formProps.setFieldValue(
                          "company_settings.payrollBusinessKey",
                          formProps.values?.company_settings?.payrollBusinessKey
                        );
                        formProps.setFieldValue("company_settings.payrollBusiness", {
                          id: b.id,
                          name: b.name,
                          contactEmailAddress: b.contactEmailAddress,
                        });
                        togglePayrollModal();
                      }}
                    />
                  </ModalBody>

                  <ModalFooter>
                    <Button color="secondary" onClick={togglePayrollModal}>
                      Cancel
                    </Button>
                  </ModalFooter>
                </Modal>
                {subscriptionModalOpen && app.currentApp?.appCode === "xero" && (
                  <SubscriptionView
                    subscription={subscriptionModalOpen}
                    PlanToggle={() => setSubscriptionModalOpen(false)}
                    companyId={formProps.values?.id}
                    tenantId={formProps.values?.tenant?.[0]?.id}
                    onSubscribed={() => {
                      setSubscriptionModalOpen(false);
                      attemptConnectTenant(formProps.values?.id);
                    }}
                  />
                )}
              </Form>
            )}
          </Formik>
        </div>
      }
    />
  );
};
export { AddUpdateCompany };
